import React, { useEffect } from "react";
import { MdCancel } from "react-icons/md";
import { useSelector } from "react-redux";

import "./portfolio.css";
import Card from "./Card";
const Portfolio = (props) => {
  const [tab, setTab] = React.useState("tab1");
  const [num, setNum] = React.useState(0);
  const [q, setQ] = React.useState("");
  const [searchArr, setSearchArr] = React.useState([]);
  const mode = useSelector((state) => state.reducer1.mode);

  useEffect(() => {
    // function changeTab(){
    for (let i = 1; i <= 6; i++) {
      document.getElementById(`tab${i}`).style.backgroundColor = "white";
      document.getElementById(`tab${i}`).style.color = "black";
    }
    document.getElementById(`${tab}`).style.backgroundColor = "#162E85";
    document.getElementById(`${tab}`).style.color = "white";
    // }
  }, [tab]);

  let portArr = [
    [
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "デジタルサイネージ/壁面装飾",
        desc: "A stay in Uchiboso with a beautiful sunset to brighten up your child's first trip",
        img: "p1.jpg",
        lowerDesc: "■ごてんば観光案内所 ▶ PRODUCT① NAME：デジタルサイネージ SIZE：デジタルサイネージ（4K・3500cd/㎡：75インチ）/アクリル板：ｈ1260ｍｍ×1900ｍｍ MATERIAL：デジタルサイネージ/アクリル板/ガラス ...",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",        
        name: "会場装飾「スイングバナー」",
        desc: "A stay in Uchiboso with a beautiful sunset to brighten up your child's first trip",
        img: "p2.jpg",
        lowerDesc: "■ 会場装飾「スイングバナー」（Inter Proto Series/KYOJO CUP） ▶ PRODUCT NAME：スイングバナー SIZE：W600mm×H2200 MATERIAL：ポンジ生地 CLIENT：株式会社インタープロト ...",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "美容室：fumies/ファミエス WEB",
        desc: "desc",
        img: "p3.png",
        lowerDesc: "■ 美容室：fumies/ファミエス Cording / Direction CLIENT：fumies 静岡県裾野市にて営業をされている『Hair & Body fumies』のWEBサイトを リニューアルさせて頂きました。 運用 ...",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 4",
        desc: "desc",
        img: "p4.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 5",
        desc: "desc",
        img: "p5.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 6",
        desc: "desc",
        img: "p6.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 7",
        desc: "desc",
        img: "p7.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 8",
        desc: "desc",
        img: "p8.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 9",
        desc: "desc",
        img: "p9.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 10",
        desc: "desc",
        img: "p10.jpg",
        lowerDesc: "desc",
      },
      {
        tab: "Events",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Event host 11",
        desc: "desc",
        img: "p11.png",
        lowerDesc: "desc",
      },
    ],
    [
      {
        tab: "Production/Management",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Production/Management",
        desc: "desc",
        img: "asset.jpeg",
        lowerDesc: "desc",
      },
    ],
    [
      {
        tab: "Creative",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Creative",
        desc: "desc",
        img: "asset.jpeg",
        lowerDesc: "desc",
      },
    ],
    [
      {
        tab: "Signs/Decoration",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Signs/Decoration",
        desc: "desc",
        img: "asset.jpeg",
        lowerDesc: "desc",
      },
    ],
    [
      {
        tab: "Web",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Web",
        desc: "desc",
        img: "asset.jpeg",
        lowerDesc: "desc",
      },
    ],
    [
      {
        tab: "Regional development",
        loc: "2909-1 Kokubo, Futtsu City, Chiba Prefecture",
        keyword: "#sauna #induction table #bonfire #baby bath #40 years old",
        name: "Regional development",
        desc: "desc",
        img: "asset.jpeg",
        lowerDesc: "desc",
      },
    ],
  ];

  function search() {
    if (q == "") {
      setSearchArr([]);
      return;
    }
    // Flatten the array to make it easier to search through all objects
    const flattenedArr = portArr.flat();

    const results = flattenedArr.filter((item) =>
      item.name.toLowerCase().includes(q.toLowerCase())
    );
    setSearchArr(results);
  }

  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        zIndex: "100",
        width: "100vw",
        height: "100vh",
        overflowY: "scroll",
      }}
    >
      <nav style={{ display: "flex" }}>
        <div style={{ display: "grid", placeItems: "center" }}>
          {mode == "day" ? (
            <img src="/img/logo-b.png" alt="" />
          ) : (
            <img src="/img/logo-w.png" alt="" />
          )}
          <p
            className="klee-one-regular"
            style={{
              color: mode == "day" ? "black" : "white",
              fontSize: ".8rem",
              // position: "relative",
              // top: "-13em"
            }}
          >
            - Make the Region -
          </p>
        </div>

        <div
          className="cancelBtn"
          style={{ color: "white" }}
          onClick={() => {
            // setTimeout(() => {
            props.cancelPF();
            // }, 400);
            document.getElementById("main").className = "animateAboutClose";
          }}
        >
          <MdCancel />
        </div>
      </nav>

      <main id="main" className="animateAbout">
        
        <div className="portCardBigCont">
          <div className="portCardCont">

          <div
            className="mainCard"
            onClick={() => {
              window.open("https://mtfuji100.com/en/", "_blank");
            }}
          >
            <img src="../img/imgone.png" alt="main card image" />
            <p>Mt.Fuji 100</p>
          </div>

          <div
            className="mainCard mainCard2"
            onClick={() => {
              window.open("https://mtfujitrailstation.com/", "_blank");
            }}
          >
            <img src="../img/imgtwo.png" alt="main card image" />
            <p>Fuji Trail Station</p>
          </div>

          <div
            className="mainCard"
            onClick={() => {
              window.open("https://acochill.com/", "_blank");
            }}
          >
            <img src="../img/imgthree.png" alt="main card image" />
            <p>Acochill Camp</p>
          </div>
          </div>

        </div>

        <div className="portSearchCont">
          <div className="interFont tabCont">
            <p
              onClick={() => {
                setTab("tab1");
                setNum(0);
                setSearchArr([]);
              }}
              id="tab1"
              className="tab"
            >
              Events
            </p>
            <p
              onClick={() => {
                setTab("tab2");
                setNum(1);
                setSearchArr([]);
              }}
              id="tab2"
              className="tab"
            >
              Production/ Management
            </p>
            <p
              onClick={() => {
                setTab("tab3");
                setNum(2);
                setSearchArr([]);
              }}
              id="tab3"
              className="tab"
            >
              Creative
            </p>
            <p
              onClick={() => {
                setTab("tab4");
                setNum(3);
                setSearchArr([]);
              }}
              id="tab4"
              className="tab"
            >
              Signs/ Decoration
            </p>
            <p
              onClick={() => {
                setTab("tab5");
                setNum(4);
                setSearchArr([]);
              }}
              id="tab5"
              className="tab"
            >
              Web
            </p>
            <p
              onClick={() => {
                setTab("tab6");
                setNum(5);
                setSearchArr([]);
              }}
              id="tab6"
              className="tab"
            >
              Regional Development
            </p>
          </div>

          <div
            className="inputCont"
          >
            <input
              style={{
                color: "black",
                borderRadius: "8px",
                marginRight: "10px",
                border: "none",
              }}
              type="text"
              placeholder="Type something"
              onChange={(e) => {
                setQ(e.target.value);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  search();
                }
              }}
            />
            <button
              style={{
                cursor: "pointer",
                backgroundColor: "#162E85",
                color: "white",
                borderRadius: "8px",
                border: "none",
                marginLeft: "8px",
                textAlign: "center",
                // height:"62px"
              }}
              onClick={() => {
                search();
              }}
            >
              Search
            </button>
          </div>
        </div>

        {searchArr.length == 0 && (
          <div className="grid-container">
            {portArr[num].map((e, index) => {
              return <Card name={e.name} desc={e.desc} img={e.img} tab={e.tab} lowerDesc={e.lowerDesc} loc={e.loc} keyword={e.keyword} />;
            })}
          </div>
        )}

        {searchArr.length > 0 && (
          <div className="grid-container">
            {searchArr.map((e, index) => {
              return <Card name={e.name} desc={e.desc} img={e.img} tab={e.tab} lowerDesc={e.lowerDesc} loc={e.loc} keyword={e.keyword} />;
            })}
          </div>
        )}
      </main>
    </div>
  );
};

export default Portfolio;
